var Context = (function () {
    var instance;

    function createInstance() {
        return {};
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
});

export default Context();



// WEBPACK FOOTER //
// /src/Context.js